import './bootstrap';

import Vue from 'vue';
import VueRouter from 'vue-router';
import vOutsideEvents from 'vue-outside-events';
import vSelect from 'vue-select';
import pagination from 'laravel-vue-pagination';
import { BootstrapVue } from 'bootstrap-vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library as fontAwesome } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleRight, faArrowLeft, faArrowRight, faCheck, faCheckCircle, faChevronRight, faExchangeAlt, faMinusCircle,
    faLongArrowAltLeft, faLongArrowAltRight, faPlus, faPlusCircle, faQuestionCircle, faSearch, faSpinner,
    faTimes, faTrashAlt, faPlaneDeparture, faPlane,
} from '@fortawesome/free-solid-svg-icons';

import router from './router';
import store from './store';
import i18n from './i18n';
import { formatPrice } from '@utilities/price';
import { formatDate, formatDateTime, formatUtcDateTime, formatTimeObject, minutesBetween } from '@utilities/date';
import { validateEmail } from '@utilities/validation';
import onlyInt from 'vue-input-only-number';
import PhoneInput from '@components/PhoneInput';

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import VModal from 'vue-js-modal';

import VueApollo from 'vue-apollo';
import BackofficeRepository from '@repositories/BackofficeRepository';

if (process.env.MIX_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.MIX_SENTRY_DSN,
        integrations: [new VueIntegration({Vue, attachProps: true})],

        beforeSend(event) {
            // Don't send 422 error to sentry
            if (event.exception && event.exception.values.length > 0 && event.exception.values[0].value === 'Request failed with status code 422') {
                return;
            }

            return event;
        },
    });
}

// Vue plugins
Vue.use(VueRouter);
Vue.use(vOutsideEvents);
Vue.use(BootstrapVue);
Vue.use(onlyInt);
Vue.use(VModal, { dialog: true });
Vue.use(VueApollo);

// Vue components
Vue.component('v-select', vSelect);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('phone-input', PhoneInput);
Vue.component('pagination', pagination);

// Vue mixins
Vue.mixin({
    methods: {
        formatPrice,
        validateEmail,
        formatDate,
        formatDateTime,
        formatUtcDateTime,
        formatTimeObject,
        minutesBetween,
    },
});

// Font awesome icons
fontAwesome.add(
    faAngleRight, faArrowLeft, faArrowRight, faCheck, faCheckCircle, faChevronRight, faExchangeAlt, faLongArrowAltLeft,
    faLongArrowAltRight, faMinusCircle, faPlus, faPlusCircle, faQuestionCircle, faSearch, faSpinner,
    faTimes, faTrashAlt, faPlaneDeparture, faPlane
);

//Apollo for graphql
const apolloClient = BackofficeRepository.bindAPIClient();
const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
});

//clear vuex localStorage for old data formats
const data_format_version = 'data-format-v2.1.3';
if(localStorage.getItem(data_format_version) !== 'true'){
    localStorage.removeItem('vuex');
}
localStorage.setItem(data_format_version, 'true');

// Main app instance
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    apolloProvider,
});
